import * as React from "react";

const PlanIcon = (props) => (
  <svg
    fill={props.fill ?? "#000000"}
    height={20}
    width={24}
    version="1.1"
    id="XMLID_124_"
    viewBox="0 0 24 24"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g id="plan">
        <g>
          <path d="M24,24H0V3h5V0h2v3h10V0h2v3h5V24z M2,22h20V5H2v3h20v2H2V22z M19,19H9v-2h10V19z M7,19H5v-2h2V19z M19,15H9v-2h10V15z M7,15H5v-2h2V15z"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default PlanIcon;
